export default "__VITE_ASSET__6UhA0sna__"